import React from 'react';
import styles from './PricingRoadmap.module.scss';

const upcomingFeatures = [
    'Full-length Diagnostic Test',
    'Score Prediction',
    'Personalized Study Plans',
    'Note-taking Feature',
    'Mistake Tracking',
    'Weekly Progress Reports',
    'Tutor Marketplace',
];

const PricingRoadmap = () => {
    return (
        <section className={styles.section}>
            <div className={styles.contentWrapper}>
                <span className={styles.label}>COMING SOON — INCLUDED IN YOUR PURCHASE</span>
                <h2 className={styles.heading}>What's being built next</h2>
                <div className={styles.tagGrid}>
                    {upcomingFeatures.map((feature, i) => (
                        <span key={i} className={styles.tag}>{feature}</span>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default PricingRoadmap;
